import HeishopClients from 'ROUTER/modules/heishop/clients.js'
import HeishopProducts from './products.js'
import HeishopPrecios from './precios.js'
import HeishopPreciosBonificacion from './preciosbonificacion.js'
import HeishopInventarios from './inventario.js'
import HeishopCpl from './cpl.js'
import HeishopTargetGroup from './target.js'
import HeishopPromociones from './promociones.js'
import HeishopMonitoreo from './monitoreo.js'


export default [
    ...HeishopClients,
    ...HeishopProducts,
    ...HeishopPrecios,
    ...HeishopPreciosBonificacion,
    ...HeishopInventarios,
    ...HeishopCpl,
    ...HeishopTargetGroup,
    ...HeishopPromociones,
    ...HeishopMonitoreo,
]